import React, { useState, useContext } from 'react';
// eslint-disable-next-line no-unused-vars
import styled from 'styled-components/macro';
import Button from 'components/atoms/Button';
import Paragraph from 'components/atoms/Paragraph';
import Link from 'components/atoms/Link';
// import Toast from 'components/molecules/Toast';
// import { useNavigate } from 'react-router-dom';
// import authService from 'services/authService';
import PasswordStrength from 'components/molecules/PasswordStrength';
import { Flex } from 'styles/helpers.styles';
import { AuthContext } from 'context/authContext';
import LoginTemplate from '../../templates/LoginTemplate';
import Field from '../../molecules/Field';
import Form, { useForm } from '../../molecules/Form';
import { StyledForm } from './SignUp.styles';

function SignUp() {
  const [form] = useForm();
  const [loading, setLoading] = useState('');
  const [password, setPassword] = useState('');
  const { onSignUp } = useContext(AuthContext);
  // const history = useNavigate();
  const onSubmit = async values => {
    setLoading(true);
    await onSignUp({ values });
    setLoading(false);
  };
  return (
    <LoginTemplate
      title="Welcome To VeonPay"
      subtitle={
        <>
          <span>Building your brand. Do it all with VeonPay Brand Manager Portal.</span>{' '}
          <Paragraph css="margin: 10px auto 0;" lg>
            Already have an account? <Link to="/">Sign in</Link>
          </Paragraph>
        </>
      }>
      <StyledForm form={form} onSubmit={onSubmit}>
        <Form.Item
          bgLight
          type="email"
          label="Email"
          name="email"
          placeholder="Your Email"
          prefix={<i className="material-icons-outlined">email</i>}
          rules={[
            { required: true, message: 'Please enter email address' },
            { email: true, message: 'Please enter a valid email' },
            { max: 40, message: 'Email should be at max 40 characters!' },
          ]}>
          <Field />
        </Form.Item>
        <Form.Item
          rules={[
            { required: true },
            { pattern: /^.{0,64}$/, message: 'Password Maximum Character Length is 64' },
            {
              password: true,
            },
          ]}
          bgLight
          type="password"
          label="Password"
          name="password"
          placeholder="Password"
          onChange={event => {
            setPassword(event.target.value);
            form.setFieldsValue({ password: event.target.value });
          }}
          value={password}
          prefix={<i className="material-icons-outlined">lock</i>}>
          <Field />
        </Form.Item>
        <PasswordStrength password={password} />
        <Form.Item
          rules={[
            { required: true, message: 'Confirm Password is required' },
            {
              transform: value => value !== form.getFieldValue('password'),
              message: 'passwords do not match',
            },
          ]}
          bgLight
          type="password"
          label="Confirm Password"
          name="confirmPassword"
          placeholder="Confirm Password"
          prefix={<i className="material-icons-outlined">lock</i>}>
          <Field />
        </Form.Item>
        <Flex
          justify="space-between"
          align="middle"
          css="
            margin-bottom: 1.875rem;
            @media (min-width: 768px) {
              margin-bottom: 2.25rem;
            }">
          <Form.Item
            type="checkbox"
            checked={form.getFieldValue('readandagree')}
            label={
              <span
                css={`
                  color: var(--secondary-text-color);
                  font-size: var(--font-size-base);
                  line-height: 24px;
                  font-weight: 500;
                `}>
                By clicking the “Sign Up” button you are creating a VeonPay account, and you agree to VeonPay{' '}
                <Link
                  // href={`${process.env.REACT_APP_MAIN_WEBSITE_URL}/terms-and-conditions`}
                  href="/"
                  target="_blank"
                  rel="noopener"
                  underline>
                  Terms and Conditions
                </Link>
              </span>
            }
            name="readandagree"
            noMargin
            rules={[{ required: true, message: 'Please Check the Terms and Conditions' }]}>
            <Field />
          </Form.Item>
        </Flex>
        <Button loading={loading} type="primary" htmlType="submit" css="margin-bottom: 30px;">
          Sign Up
        </Button>
      </StyledForm>
    </LoginTemplate>
  );
}

export default SignUp;
